module.exports = __webpack_public_path__ + "img/website.783969e3.png";